<script>
import {Dialog} from "vant";
  export default {
    name: "AppLayout",
    components: {
      [Dialog.name]: Dialog,
    },
    data() {
      return {
        addFontKhmer: false,
        exitApp: false,
      };
    },
    mounted() {
      this.$bridge.registerHandler("closeApp", () => {
        this.handleCloseApp();
      });
    },
    methods: {
      handleCloseApp() {
        this.exitApp = true;
      },
      onCancel() {
        this.exitApp = false;
      },
      clickLeave() {
        this.$bridge.callHandler("closeApp").then(() => {}).catch(() => {});
      },
    },
  
    created() {
      if(this.$i18n.locale == "kh") {
        this.addFontKhmer = true;
      }else {
        this.addFontKhmer = false;
      }
    },
  };
</script>

<template>
    <div v-if="exitApp">
      <div class="van-overlay" style="z-index: 2001;"></div>
      <div class="van-popup van-popup--center van-dialog" role="dialog" tabindex="0" aria-labelledby="VET EXPRESS" style="z-index: 2001;">
          <div class="van-dialog__header" :class="{langKh: addFontKhmer}">{{$t('message.information') }}</div>
          <div class="van-dialog__content">
              <div class="van-dialog__message van-dialog__message--has-title" :class="{langKh: addFontKhmer}">{{$t('message.exitApp') }}</div>
          </div>
          <div class="van-hairline--top van-dialog__footer">
              <button type="button" @click="onCancel()" class="van-button van-button--default van-button--large van-dialog__cancel">
                  <div class="van-button__content">
                      <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.no') }}</span>
                  </div>
              </button>
              <button type="button" @click="clickLeave()" class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left">
                  <div class="van-button__content">
                      <span class="van-button__text" :class="{langKh: addFontKhmer}">{{$t('message.exit') }}</span>
                  </div>
              </button>
          </div>
      </div>
    </div>
    <nav>
      <router-view />
    </nav>
</template>
<style lang="scss">
  body {background: #FFF;}
</style>
